import { NgModule } from '@angular/core';

import {SharedModule} from "../../shared/shared.module";
import {CercaApiService} from "./shared/cerca-api.service";
import {CercaNavigationService} from "./shared/cerca-navigation.service";
import {CercaService} from "./shared/cerca.service";
import {CercaFormComponent} from "./cerca-form/cerca-form.component";
import {CercaListComponent} from "./cerca-list/cerca-list.component";
import {CercaRoutingModule} from "./cercas-routing.module";
import {CercasComponent} from "./cercas.component";

@NgModule({
    imports: [
        SharedModule,
        CercaRoutingModule
    ],
    providers: [
        CercaApiService,
        CercaNavigationService,
        CercaService
    ],
    declarations: [
        CercasComponent,
        CercaFormComponent,
        CercaListComponent
    ],
    exports: [
        CercaListComponent
    ]
})
export class CercaModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/cercas/cercas.module.ts
 **/